// -------------------------------------------------    -------------------------
// #141 - Wild Challenge Signup Form
// --------------------------------------------------------------------------
// Author:      Alix Richards
// Email:       frontend@zonedigital.com
// URL:         http://zonedigital.com
// Copyright:   Copyright (c) 2016, zonedigital.com. All rights reserved.
// Version:     1
// --------------------------------------------------------------------------

'use strict';

var $ = require('jquery');

module.exports = function () {

  function showPostCodeLookup() {
    var altAddress = $('[data-binding="wild-challenge-alt-address"]');
    var altAddressField = $('[data-binding="wild-challenge-address-lookup"]');

    altAddress.on('click', function () {
      altAddressField.slideDown();
    });
  }

  function showFurtherField() {
    var select = $('[data-binding="wild-challenge-award"]');
    var furtherDetails = $('[data-binding="wild-challenge-award-details"]');
    var showInput;

    select.on('change', function () {
      showInput = $(this).val();
      if (showInput === 'true') {
        furtherDetails.slideDown();
      } else {
        furtherDetails.val('');
        furtherDetails.slideUp();
      }
    });
  }

  function showSchoolAddressField() {
    var wildChallengeGroupType = $('[data-binding="wild-challenge-group-type"]');
    var wildChallengeAltAddressFields = $('[data-binding="wild-challenge-alt-address-fields"]');

    wildChallengeGroupType.on('change', function () {
      var groupType = $(this).val();
      if (groupType === 'School') {
        wildChallengeAltAddressFields.slideDown();
      } else {
        wildChallengeAltAddressFields.slideUp();
      }
    });
  }

  function init() {
    showPostCodeLookup();
    showFurtherField();
    showSchoolAddressField();
  }

  return {
    init: init
  };
};


//////////////////
// WEBPACK FOOTER
// ./src/scripts/modules/wild-challenge/wild-challenge-signup-form.js
// module id = 255
// module chunks = 0